import {InjectionToken, Signal} from '@angular/core';
import {UmpireSurveyAnswer, UmpireSurvey} from '@tisa-group/models';

export interface SurveyHandlers {
  isUserLoggedIn: () => boolean;
  localUserAnswer: Signal<UmpireSurveyAnswer | null>;
  onAnswerSelected: (answer: UmpireSurveyAnswer) => void;
  onLoginRequested: () => void;
}

export const SURVEY_HANDLERS = new InjectionToken<SurveyHandlers>('SURVEY_HANDLERS');
